import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { PriceSurveyValidationSchema } from '@/features/priceSurvey/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseCreatePriceSurvey {
  onSuccess: (response: AxiosResponse) => void
  onError: (error: AxiosError) => void
}

export const useCreatePriceSurvey = ({ onSuccess, onError }: UseCreatePriceSurvey) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createPriceSurvey'],
    mutationFn: async (form: PriceSurveyValidationSchema) => {
      const price_survey = {
        survey_conducted_at: form.survey_conducted_at,
        geo_geoables_attributes: form.geo_geoables_attributes?.map((geo) => ({
          geo_id: geo.value,
          geo_type: 'Geo::City',
        })),
        price_survey_products_attributes: form.price_survey_products_attributes?.map((product) => ({
          product_id: product.product_id,
          price: unFormatCurrency(product.price),
        })),
        evidences_attachments_attributes: form.evidences_attachments_attributes?.map((attachment) => ({
          blob_id: attachment.id,
        })),
      }

      return privateAxios.post('/price_surveys', { price_survey })
    },
    onSuccess,
    onError,
  })
}
